import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { TestBackup } from 'src/app/models/test_backup_model';
import { CleaverService } from 'src/app/services/cleaver.service';
import { TestService } from 'src/app/services/test.service';
import Swal from 'sweetalert2';

declare var jQuery:any;
declare var $:any;

@Component({
  selector: 'app-cleaver',
  templateUrl: './cleaver.component.html',
  styleUrls: ['./cleaver.styles.css']
})
export class CleaverComponent implements OnInit {
  
  @ViewChild('instructions') instructions: ElementRef;
  public questions;
  public index;
  public answers=[];
  public orderAnswers=[];    ///////[0]=1    la primer pregunta primero [3]=4 la cuarta va ultima
  public actualIndex=0;
  public testData;
  public photoTaked = false;
  public trigger = false;

  public selectedQuestion:any={
    "title":"",
    "opcA":{"text":""},
    "opcB":{"text":""},
    "opcC":{"text":""},
    "opcD":{"text":""},

  };

  public scoreCounter={
    "m":{
      "d":0,
      "i":0,
      "s":0,
      "c":0
    },
    "l":{
      "d":0,
      "i":0,
      "s":0,
      "c":0
    },
    "t":{
      "d":0,
      "i":0,
      "s":0,
      "c":0
    },
  }

  public score = {
    "m":{
      "d":0,
      "i":0,
      "s":0,
      "c":0
    },
    "l":{
      "d":0,
      "i":0,
      "s":0,
      "c":0
    },
    "t":{
      "d":0, //empuje
      "i":0, //influencia
      "s":0,  //constancia
      "c":0   //apego
    },

  }

  public originalScore = {
    "m":{
      "d":0,
      "i":0,
      "s":0,
      "c":0
    },
    "l":{
      "d":0,
      "i":0,
      "s":0,
      "c":0
    },
    "t":{
      "d":0, //empuje
      "i":0, //influencia
      "s":0,  //constancia
      "c":0   //apego
    },

  }

  public texts;


  
  constructor(private cleaverService: CleaverService, private testService: TestService, private router:Router) {
    this.testService.getTexts().subscribe(
      resp=>{
        this.texts = resp;
      },
      err=>console.log(err)
    )
    if(!this.testService.selectedTestData){
      this.router.navigateByUrl('dashboard/requestedTests');
    }
    this.testData = this.testService.selectedTestData;
    this.cleaverService.getQuestions().subscribe(
      async resp =>{
        this.questions = resp;

        this.questions.map(q=>{
          for (let opc in q){
            if(q[opc].m=='d') {
              this.scoreCounter.m.d=this.scoreCounter.m.d+1;
              this.scoreCounter.t.d=this.scoreCounter.t.d+1;
            }
            if(q[opc].m=='i') {
              this.scoreCounter.m.i=this.scoreCounter.m.i+1;
              this.scoreCounter.t.i=this.scoreCounter.t.i+1;
            }
            if(q[opc].m=='s') {
              this.scoreCounter.m.s=this.scoreCounter.m.s+1;
              this.scoreCounter.t.s=this.scoreCounter.t.s+1;
            }
            if(q[opc].m=='c') {
              this.scoreCounter.m.c=this.scoreCounter.m.c+1;
              this.scoreCounter.t.c=this.scoreCounter.t.c+1;
            }
            if(q[opc].l=='d') {
              this.scoreCounter.l.d=this.scoreCounter.l.d+1;
              this.scoreCounter.t.d=this.scoreCounter.t.d+1;
            }
            if(q[opc].l=='i') {
              this.scoreCounter.l.i=this.scoreCounter.l.i+1;
              this.scoreCounter.t.i=this.scoreCounter.t.i+1;
            }
            if(q[opc].l=='s') {
              this.scoreCounter.l.s=this.scoreCounter.l.s+1;
              this.scoreCounter.t.s=this.scoreCounter.t.s+1;
            }
            if(q[opc].l=='c') {
              this.scoreCounter.l.c=this.scoreCounter.l.c+1;
              this.scoreCounter.t.c=this.scoreCounter.t.c+1;
            }
          }
        })
        await this.checkBackup();

      },
      err=>{
        console.log(err);
      }
      )

  }


  ngOnInit(): void {
  }

  public backupTimer: any;
  public backup?: TestBackup;

  async checkBackup(){
    let backup = await this.testService.getTestBackups({testId: this.testService.selectedTestData._id}).toPromise()
    if (backup && backup.length > 0) {
      this.startBackupTimer()
      this.backup = backup[0];
      this.index = backup[0].data.index;
      this.score = backup[0].data.score || {};
      this.originalScore = backup[0].data.originalScore || {};
      this.answers = backup[0].data.answers;
      this.selectedQuestion = this.questions[this.index]
      this.testService.testStarted = true;
      $("#myModal").modal("show");
      this.testService.testStarted = true;
      this.clear()
      if (this.testData.camera){
        setTimeout(() => {
          this.trigger = !this.trigger;
        }, Math.floor(Math.random() * 60000 + 240000));
      }
      var testData = this.testService.selectedTestData;
      testData.isStarted = true;
      this.testService.updateTest(testData).subscribe();
    }
  }

  startBackupTimer(){
    console.log('Iniciando backup timer');
    this.backupTimer = setInterval(() => {
      if (this.testService.testStarted) {
        let data = {
          index: this.index,
          score: this.score,
          answers: this.answers,
          originalScore: this.originalScore
        }
        let backup: TestBackup = {
          testId: this.testService.selectedTestData._id,
          userEmail: this.testService.selectedTestData.client,
          userName: this.testService.selectedTestData.evaluatedName,
          data: data
        }
        if (this.backup?._id){
          backup._id = this.backup._id;
        }
        this.testService.createTestBackup(backup).subscribe(
          res => {
            this.backup = res;
            console.log('Backup guardado', res);
          },
          err => console.log(err)
        );
      }
    }, 15000); // Backup cada 15 segundos
  }

  ngOnDestroy(){
    if (this.backupTimer) {
      clearInterval(this.backupTimer);
    }
  }

  reload(){
    location.reload()
  }

  ngAfterViewInit(){
    this.testService.getTexts().subscribe(
      resp=>{
        this.texts = resp;
        setTimeout(()=>{
          this.instructions.nativeElement.innerHTML = this.texts.cleaverInstructions;
        }, 500)
      },
      err=>console.log(err)
    )    

  }

  startTest(){
    this.startBackupTimer()
    this.testService.testStarted = true;

    if (this.testData.camera){
      setTimeout(() => {
        this.trigger = !this.trigger;
      }, Math.floor(Math.random() * 60000 + 240000));
    }
    var testData = this.testService.selectedTestData;
    testData.isStarted = true;
    testData.startDate = Date.now();
    this.testService.updateTest(testData).subscribe();

    this.actualIndex = 0;
    this.selectedQuestion = this.questions[0];
    this.index = 0;
    this.score = {
      "m":{
        "d":0,
        "i":0,
        "s":0,
        "c":0
      },
      "l":{
        "d":0,
        "i":0,
        "s":0,
        "c":0
      },
      "t":{
        "d":0,
        "i":0,
        "s":0,
        "c":0
      },
    };
    this.orderAnswers[0]=0;
    this.orderAnswers[1]=0;
    this.orderAnswers[2]=0;
    this.orderAnswers[3]=0;

    this.answers = [];
    
  }

  select(opc){

    var added = false;
    if(this.actualIndex<2){
      for (var i = 0; i<=this.actualIndex; i++){
        if(this.orderAnswers[(parseInt(opc))]!=0){
          added = true;
        }
      }
      if (!added){
        this.orderAnswers[opc]=this.actualIndex+1;
        this.actualIndex++;


      }
    }

  }

  nextQuestion(){

    if(this.actualIndex==2){
      var a = {
        1:this.orderAnswers[0],
        2:this.orderAnswers[1],
        3:this.orderAnswers[2],
        4:this.orderAnswers[3]
      }

      if(this.orderAnswers[0]=='1'){
        if(this.selectedQuestion.opcA!='vacio'){
          this.score.m[this.selectedQuestion.opcA.m]=this.score.m[this.selectedQuestion.opcA.m]+1;
          this.originalScore.m[this.selectedQuestion.opcA.m]=this.originalScore.m[this.selectedQuestion.opcA.m]+1;
        }
      }
      if(this.orderAnswers[1]=='1'){
        if(this.selectedQuestion.opcB!='vacio'){
          this.score.m[this.selectedQuestion.opcB.m]=this.score.m[this.selectedQuestion.opcB.m]+1;
          this.originalScore.m[this.selectedQuestion.opcB.m]=this.originalScore.m[this.selectedQuestion.opcB.m]+1;
        }
      }
      if(this.orderAnswers[2]=='1'){
        if(this.selectedQuestion.opcA!='vacio'){
          this.score.m[this.selectedQuestion.opcA.m]=this.score.m[this.selectedQuestion.opcA.m]+1;
          this.originalScore.m[this.selectedQuestion.opcA.m]=this.originalScore.m[this.selectedQuestion.opcA.m]+1;
        }
      }
      if(this.orderAnswers[3]=='1'){
        if(this.selectedQuestion.opcA!='vacio'){
          this.score.m[this.selectedQuestion.opcA.m]=this.score.m[this.selectedQuestion.opcA.m]+1;
          this.originalScore.m[this.selectedQuestion.opcA.m]=this.originalScore.m[this.selectedQuestion.opcA.m]+1;
        }
      }
      if(this.orderAnswers[0]=='2'){
        if(this.selectedQuestion.opcA!='vacio'){
          this.score.l[this.selectedQuestion.opcA.l]=this.score.l[this.selectedQuestion.opcA.l]+1;
          this.originalScore.l[this.selectedQuestion.opcA.l]=this.originalScore.l[this.selectedQuestion.opcA.l]+1;
        }
      }
      if(this.orderAnswers[1]=='2'){
        if(this.selectedQuestion.opcB!='vacio'){
          this.score.l[this.selectedQuestion.opcB.l]=this.score.l[this.selectedQuestion.opcB.l]+1;
          this.originalScore.l[this.selectedQuestion.opcB.l]=this.originalScore.l[this.selectedQuestion.opcB.l]+1;
        }
      }
      if(this.orderAnswers[2]=='2'){
        if(this.selectedQuestion.opcA!='vacio'){
          this.score.l[this.selectedQuestion.opcA.l]=this.score.l[this.selectedQuestion.opcA.l]+1;
          this.originalScore.l[this.selectedQuestion.opcA.l]=this.originalScore.l[this.selectedQuestion.opcA.l]+1;
        }
      }
      if(this.orderAnswers[3]=='2'){
        if(this.selectedQuestion.opcA!='vacio'){
          this.score.l[this.selectedQuestion.opcA.l]=this.score.l[this.selectedQuestion.opcA.l]+1;
          this.originalScore.l[this.selectedQuestion.opcA.l]=this.originalScore.l[this.selectedQuestion.opcA.l]+1;
        }
      }

      this.answers.push(a);
      this.orderAnswers[0]=0;
      this.orderAnswers[1]=0;
      this.orderAnswers[2]=0;
      this.orderAnswers[3]=0;
      this.actualIndex=0;
      this.index = this.index + 1;
      this.selectedQuestion = this.questions[this.index];
      //console.log(this.index);
      //console.log(this.selectedQuestion);
      if(!this.selectedQuestion){
        this.trigger = !this.trigger;
        this.selectedQuestion = {
          "title":"Test finalizado",
          "opcA":{"text":"--"},
          "opcB":{"text":"--"},
          "opcC":{"text":"--"},
          "opcD":{"text":"--"},
          
        }
        //console.log(this.scoreConverted);
 
        this.score;
        this.correctScore();
        Swal.fire({
          text:'Has concluido esta evaluación. Agradecemos tu participación',
          icon:'success',
          confirmButtonText:'Salir'
        });
        jQuery("#myModal").modal("hide");
        this.cleaverService.createReport(this.score, this.answers, this.originalScore).subscribe(
          res=>{
            
            var testData = this.testService.selectedTestData;
            testData.isCompleted = true;
            testData.reportId = res._id;
            testData.completeDate = Date.now();
            this.testService.updateTest(testData).subscribe(
              r=>{
                this.router.navigateByUrl('dashboard/requestedTests');
              },
              e=>console.log(e)
            );
          },
          err=> console.log(err)
        )
        
      }
    }else{
      let timerInterval;
      Swal.fire({
        title: 'Debe seleccionar dos opciones',
        html: '',
        timer: 2000,
        timerProgressBar: true,
        
        onClose: () => {
          clearInterval(timerInterval)
        }
      }).then((result) => {
        /* Read more about handling dismissals below */
        if (result.dismiss === Swal.DismissReason.timer) {
          
        }
      })
    }
  }

  clear(){
    this.orderAnswers[0]=0;
    this.orderAnswers[1]=0;
    this.orderAnswers[2]=0;
    this.orderAnswers[3]=0;
    this.actualIndex=0;
  }

  correctScore(){

    for (let s in this.score.t){
      if (this.scoreCounter.t[s]>0&&this.score.m[s]>0) this.score.t[s]=((this.score.m[s]-this.score.l[s]+this.scoreCounter.l[s])/this.scoreCounter.t[s])*100;
      this.originalScore.t[s] = this.originalScore.m[s]-this.originalScore.l[s];
    }

    for (let s in this.score.m){

      if (this.scoreCounter.m[s]>0) this.score.m[s]=(this.score.m[s]/this.scoreCounter.m[s])*100;
    }
    for (let s in this.score.l){
      if (this.scoreCounter.l[s]>0) this.score.l[s]=(this.score.l[s]/this.scoreCounter.l[s])*100;
    }

  }

}
